import { applyMiddleware, createStore } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunkMiddleware from "redux-thunk";

import root from "./reducers/root";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["cart", "customer"],
};

const persistedReducer = persistReducer(persistConfig, root);

const store = createStore(persistedReducer, applyMiddleware(thunkMiddleware));

export default store;
